const defaultDateFormatOptions: Intl.DateTimeFormatOptions = {
  day: 'numeric',
  month: 'numeric',
  year: 'numeric',
  hour: '2-digit',
  minute: '2-digit',
};

export function formatDate(timestamp: Date | null): string {
  if (!timestamp) return '-';
  return timestamp.toLocaleDateString('pt-BR', defaultDateFormatOptions);
}

// Receive an BR-like date format and returns the Date object
export function parseDate(dateStr: string | null): Date | null {
  if (!dateStr) return null;
  const result = Array.from(dateStr.matchAll(/(\d{2})-(\d{2})-(\d{4}) (\d{2}):(\d{2}):(\d{2})/g))[0];

  if (!result || !result.length) return new Date('');

  const [, day, month, year, hour, minute, second] = result;
  const newDateStr = `${year}-${month}-${day}T${hour}:${minute}:${second}`;

  return new Date(newDateStr);
}

export function formatStringDate(dateStr: string | null): string {
  return formatDate(parseDate(dateStr));
}

export function formatNumbers(value: number): string {
  return value.toLocaleString('pt-BR');
}

export function formatDateFromMinutes(value: number): string {
  const h = Math.floor(value / 60);
  const m = value % 60;
  const hours = `00${h}`.slice(-2);
  const minutes = `00${m}`.slice(-2);

  return `${hours}h:${minutes}min`;
}
